import { createPortal } from "react-dom";
import React from "react";

interface FloatingPortalProps {
  children: React.ReactNode;
}

const FloatingPortal: React.FC<FloatingPortalProps> = ({ children }) => {
  return createPortal(children, document.body);
};

export default FloatingPortal;
